var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfoMarkets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_info_markets",
    transform: "translate(-188 -361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 32,
    height: 32,
    transform: "translate(188 361)",
    fill: "rgba(0,0,0,0.5)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "more_info",
    "data-name": "more info",
    transform: "translate(173.392 -168.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(23 538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M7.608,0a7.608,7.608,0,1,0,7.608,7.608A7.6,7.6,0,0,0,7.608,0Zm0,14.154a6.546,6.546,0,1,1,6.546-6.546A6.554,6.554,0,0,1,7.608,14.154Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(6.753 6.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M230.915,213.4c-.5,0-.856.211-.856.523v4.235c0,.267.356.534.856.534.478,0,.867-.267.867-.534v-4.235C231.782,213.608,231.393,213.4,230.915,213.4Z",
    transform: "translate(-230.059 -213.397)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(6.697 3.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M229.287,134.208a.8.8,0,1,0,.9.789A.861.861,0,0,0,229.287,134.208Z",
    transform: "translate(-228.375 -134.208)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoMarkets);
export default __webpack_public_path__ + "static/media/icon_info_markets.1d91cab73085586484ff0142de8ddd5f.svg";
export { ForwardRef as ReactComponent };